import { DateTime } from 'luxon';

/**
 * GOOGLE ADS ATTRIBUTION (2026-09-24).
 *
 * The landing site (holidayhomecleaning.ae) gives a visitor who came from a
 * Google ad a ref like GADS-7K2QD and passes it — with the utm tags and the
 * gclid — on every link into the portal. This keeps it on the device for 30
 * days, the same window the landing site uses, so somebody who looks today and
 * registers next week is still credited to the ad.
 *
 * /register sends it with the sign-up; the server turns it into a lead sourced
 * "App - Google Ads" (leadsService.sanitizeAd decides what counts as an ad).
 */
const KEY = 'hhc_ad';
const ADS_ID = 'AW-18471794937';
// Google Ads conversion action "Portal registration" (Sign-up).
const REGISTRATION_SEND_TO = 'AW-18471794937/iW7zCNDA8YMdEPnxhOhE';

export function captureAdVisit() {
    try {
        const q = new URLSearchParams(window.location.search);
        const gclid = q.get('gclid') || q.get('gbraid') || q.get('wbraid') || '';
        const ref = (q.get('ref') || '').match(/GADS-[A-Z0-9]{5}/i)?.[0]?.toUpperCase() || '';
        const utmAd = q.get('utm_source') === 'google' && q.get('utm_medium') === 'cpc';
        if (!ref && !gclid && !utmAd) return;
        localStorage.setItem(KEY, JSON.stringify({
            ref,
            utm_source: q.get('utm_source') || 'google',
            utm_medium: q.get('utm_medium') || 'cpc',
            utm_campaign: q.get('utm_campaign') || '',
            utm_content: q.get('utm_content') || '',
            gclid,
            landing: window.location.pathname,
            at: DateTime.now().setZone('Asia/Dubai').toISO(),
            exp: DateTime.now().plus({ days: 30 }).toMillis(),
        }));
        loadAdsTag(); // lets Google's own linker keep the click id as well
    } catch (e) { /* storage blocked — attribution is best-effort */ }
}

export function readAdVisit() {
    try {
        const v = JSON.parse(localStorage.getItem(KEY) || 'null');
        return v && v.exp > DateTime.now().toMillis() ? v : null;
    } catch (e) {
        return null;
    }
}

let tagLoaded = false;
function gtag() { window.dataLayer.push(arguments); } // eslint-disable-line prefer-rest-params

/** Google's tag, loaded only where it is needed (an ad arrival, /register). */
export function loadAdsTag() {
    if (tagLoaded) return;
    tagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || gtag;
    window.gtag('js', new Date());
    window.gtag('config', ADS_ID);
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
    document.head.appendChild(s);
}

/** A new account exists — count it as a Google Ads "Portal registration". */
export function trackRegistrationConversion() {
    loadAdsTag();
    window.gtag('event', 'conversion', { send_to: REGISTRATION_SEND_TO });
}
